export default {"src":"https://images-cdn.curipod.com/d-96f228ab/_next/static/media/common_sense_media.9c180185.svg","height":123,"width":300};